import raw from "../../data/tables/art/packs/dropfront/grips.json";
import type { GripPack } from "./grip-resolve";

/** Dropfront grip SSOT — JSON tuples widen to number[]; cast once. */
export const dropfrontGripPack = raw as unknown as GripPack;
